import { render } from "./OnboardingFirstStep.vue?vue&type=template&id=1201b748&scoped=true&ts=true"
import script from "./OnboardingFirstStep.vue?vue&type=script&lang=ts"
export * from "./OnboardingFirstStep.vue?vue&type=script&lang=ts"

import "./OnboardingFirstStep.vue?vue&type=style&index=0&id=1201b748&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1201b748"]])

export default __exports__